import styled from "styled-components";

export const PickUpContainer = styled.div`
  display: flex;
  height: calc(100vh - 85px);
  .content {
    padding: 0 20px;
    background: #fff;
  }
  .orders {
    width: 300px;
    height: 100%;
    background: #f7f7f7;
    .tabs {
      height: 75px;
      line-height: 75px;
      overflow: hidden;
      ul {
        height: 100%;
        li {
          width: 50%;
          height: 100%;
          overflow: hidden;
          text-align: center;
          display: inline-block;
          font-size: 22px;
          background: #245dab;
          color: #fff;
          transition: 0.3s;
          &.active {
            font-size: 26px;
            font-weight: 800;
            color: #245dab;
            background: transparent;
          }
        }
      }
    }
    .date {
      font-size: 28px;
      height: 75px;
      line-height: 75px;
      text-align: center;
      font-weight: 700;
    }
  }
  @media screen and (max-width: 1050px) {
    .orders {
      width: 250px;
      .tabs {
        height: 50px;
        line-height: 50px;
        ul li {
          font-size: 20px;
          height: 50px;
          line-height: 50px;
          &.active {
            font-size: 24px;
          }
        }
      }
      .date {
        height: 50px;
        line-height: 50px;
        font-size: 20px;
      }
    }
    .container .content {
      width: calc(100% - 265px);
      padding: 0 10px;
    }
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    height: calc(100vh - 50px);
    .content {
      height: calc(100% - 84px);
      width: 100%;
      padding: 0;
      background: transparent;
      .order {
        height: 100%;
        padding: 10px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 10px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #5a5a5a;
          border-radius: 10px;
          border: 2px solid #d9d9d9;
        }
        &::-webkit-scrollbar-track {
          background-color: #d9d9d9;
          border-radius: 10px;
        }
      }
    }

    .info {
      .label {
        font-size: 20px;
        padding: 0 20px;
        height: 54px;
        line-height: 54px;
        font-weight: 700;
      }
      .tabs {
        ul {
          display: flex;
          align-items: center;
          padding: 0 20px;
          li {
            width: calc(100% / 3);
            height: 30px;
            font-size: 12px;
            border-bottom: 3px solid transparent;
            text-align: center;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #9e9e9e;
            transition: 0.2s;
            &.active {
              background: none;
              color: #000;
              border-bottom: 3px solid #255dac;
            }
          }
        }
      }
    }
  }
`;

export const OrdersSection = styled.div`
  height: calc(100% - 75px);
  overflow-y: hidden;
  font-size: 20px;
  .newOrders {
    height: 45%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #5a5a5a;
      border-radius: 10px;
      border: 2px solid #d9d9d9;
    }
    &::-webkit-scrollbar-track {
      background-color: #d9d9d9;
      border-radius: 10px;
    }
    ul {
      li {
        &.none {
          color: #000;
        }
        color: #245dab;
        padding: 10px 15px;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: center;
        gap: 10px;
        transition: 0.3s;
        position: relative;
        &:last-child {
          border-bottom: none;
        }
        .dot {
          position: absolute;
          width: 10px;
          height: 10px;
          background: #635151;
          top: 10px;
          right: 10px;
          border-radius: 50%;
        }
        img {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }
        &.active {
          background: rgba(0, 0, 0, 0.2);
        }
        .orderInfo {
          width: calc(100% - 60px);
          span {
            display: block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &.tit {
              font-size: 20px;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
  .inProgressOrders {
    height: 55%;
    .inProgressInfo {
      padding: 0 15px;
      height: 70px;
      line-height: 70px;
      color: #245dab;
      font-weight: 600;
    }
    ul {
      max-height: calc(100% - 70px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
      li {
        &:first-child {
          margin-top: 0;
        }
        &.none {
          border-radius: 0;
          margin: 0;
          border-radius: 0;
          background: transparent;
          padding: 0 15px;
        }
        padding: 15px;
        background: #efefef;
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 20px;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
        border-radius: 20px;
        transition: 0.3s;
        &.active {
          background: rgba(0, 0, 0, 0.2);
        }
        img {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }
        .inProgressOrderItem {
          width: calc(100% - 140px);
          span {
            display: block;
            font-size: 18px;
            &:first-child {
              font-weight: 700;
            }
          }
        }
        .orderProgress {
          width: 60px;
          height: 60px;
          background: #fff;
          border-radius: 50%;
          position: relative;
          display: inline-block;
          overflow: hidden;
          &.gray .wave {
            background: rgba(27, 27, 27, 0.4);
          }

          &.red .wave {
            background: rgba(255, 47, 47, 0.4);
          }

          &.yellow .wave {
            background: rgba(214, 154, 41, 0.4);
          }

          &.green .wave {
            background: rgba(62, 204, 47, 0.4);
          }

          .progressRemaining {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            text-align: center;
            font-weight: 700;
            font-size: 16px;
            z-index: 50;
            span {
              white-space: nowrap;
            }
          }
          .wave {
            transition: top 0.75s ease;
            opacity: 0.4;
            position: absolute;
            top: 10px;
            left: 50%;
            background: rgba(0, 0, 0, 0.2);
            transform-origin: 50% 48%;
            border-radius: 41%;
            transition-duration: 0.75s;
            transition-property: margin-bottom;
            transition-timing-function: ease;
            &:nth-child(1) {
              width: 130px;
              height: 130px;
              animation: waveMove 7000ms infinite ease-in-out;
              animation-delay: 0s;
            }
            &:nth-child(2) {
              width: 150px;
              height: 150px;
              animation: waveMove 10000ms infinite ease-in-out;
              animation-delay: 1s;
            }

            &:nth-child(3) {
              width: 140px;
              height: 140px;
              animation: waveMove 7000ms infinite ease-in-out;
              animation-delay: 2s;
            }
          }
        }
      }
    }
    @keyframes waveMove {
      0% {
        transform: translateX(-50%) scale(1) rotate(0deg);
      }
      25% {
        transform: translateX(-50%) scale(1.05) rotate(90deg);
      }
      50% {
        transform: translateX(-50%) scale(1) rotate(180deg);
      }
      75% {
        transform: translateX(-50%) scale(1.05) rotate(270deg);
      }
      100% {
        transform: translateX(-50%) scale(1) rotate(360deg);
      }
    }
  }
  @media screen and (max-width: 1050px) {
    height: calc(100% - 50px);
    .newOrders ul li {
      img {
        width: 40px;
        height: 40px;
      }
      .orderInfo {
        width: calc(100% - 50px);
        span {
          font-size: 14px;
          &.tit {
            font-size: 18px;
          }
        }
      }
    }
    .inProgressOrders ul li {
      gap: 5px;
      margin: 10px;
      .orderProgress {
        width: 40px;
        height: 40px;
        .progressRemaining {
          width: 35px;
          height: 35px;
          line-height: 35px;
          font-size: 12px;
        }
      }
      .inProgressOrderItem {
        width: calc(100% - 80px);
        span {
          font-size: 14px;
        }
      }
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
`;

export const DetailsInfoContainer = styled.div`
  height: 110px;
  border-bottom: 1px solid #000;
  display: flex;
  font-weight: 700;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .info {
    display: flex;
    align-items: center;
    gap: 15px;
    max-width: calc(100% - 360px);
    .status {
      width: 65px;
      height: 65px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .infoImage {
      width: 50px;
      height: 50px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .infoText {
      min-width: 200px;
      span:last-child {
        font-size: 20px;
      }
    }
    span {
      display: block;
      &:first-child {
        font-size: 24px;
      }
      &:last-child {
        color: #666666;
      }
    }
  }
  .time {
    span {
      display: block;
      font-size: 20px;
    }
  }
  .actions {
    display: flex;
    gap: 10px;
    height: 70px;
    line-height: 70px;
    > button {
      border: 1px solid #666666;
      width: 100px;
      height: 100%;
      text-align: center;
      font-weight: 700;
      background: transparent;
      font-size: 22px;
    }
    .notify {
      height: 100%;
      border: 1px solid #666666;
      width: 140px;
      overflow-y: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: none;
      background: #255dac;
      color: #fff;
      font-size: 16px;
      font-weight: normal;
      .icon {
        font-size: 34px;
        svg {
          display: block;
        }
      }
    }
    .stepper {
      height: 100%;
      border: 1px solid #666666;
      width: 170px;
      overflow-y: hidden;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      button {
        width: 30px;
        height: 30px;
        border: none;
        background: #000;
        color: #fff;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          display: block;
          margin: auto;
        }
      }
      span {
        display: inline-block;
        width: 75px;
        font-size: 22px;
        text-align: center;
      }
    }
    .stepper + button {
      background: #255dac;
      color: #fff;
    }
    .cancel {
      background: rgb(183, 74, 74);
      color: #fff;
    }
  }
  @media screen and (max-width: 1050px) {
    display: block;
    padding: 10px 0;
    height: 120px;
    position: relative;
    .info {
      max-width: none;
      width: 100%;
      margin-bottom: 10px;
      gap: 5px;
      .infoImage {
        width: 40px;
        height: 40px;
      }
      .status {
        margin-left: auto;
        width: 50px;
        height: 50px;
      }
      .infoText {
        max-width: calc(100% - 250px);
        span {
          &:last-child {
            font-size: 16px;
          }
          &:first-child {
            font-size: 16px;
          }
        }
      }
    }
    .time {
      position: absolute;
      top: 50%;
      right: 60px;
      transform: translateY(-50%);
      span {
        font-size: 14px;
      }
    }
    &.CANCELLED,
    &.PICKUP {
      height: 76px;
    }
    > strong {
      display: block;
      margin: auto;
    }
    .actions {
      height: 35px;
      line-height: 35px;
      font-size: 18px;
      > button {
        font-size: 18px;
      }
      .notify {
        width: 160px;
        font-size: 18px;
        display: block;
        .icon {
          display: none;
        }
      }
      .stepper {
        justify-content: space-between;
        button {
          width: 35px;
          height: 35px;
        }
        span {
          width: 50px;
          font-size: 18px;
        }
      }
    }
  }
`;

export const DetailsContentContainer = styled.div`
  height: calc(100% - 110px);
  > div {
    min-height: 70px;
    display: flex;
    border-bottom: 1px solid #000;
    &:nth-child(5) {
      border-bottom: none;
    }
    &:last-child {
      min-height: auto;
      border-bottom: none;
    }
    span.label {
      font-weight: 700;
    }
  }
  .notOrder {
    align-items: center;
    justify-content: center;
    height: calc(100% - 110px);
    padding: 0;
    .bg {
      width: 100%;
      height: 340px;
      background: #dcdcdc;
      font-weight: 700;
      line-height: 340px;
      text-align: center;
    }
  }
  .pickupInfo,
  .tel {
    justify-content: space-between;
    align-items: center;
  }

  @media screen and (max-width: 1050px) {
    height: calc(100% - 120px);
    &.CANCELLED,
    &.PICKUP {
      height: calc(100% - 76px);
    }
    > div {
      min-height: 50px;
      font-size: 16px;
      span.label {
        font-size: 20px;
      }
    }
    .pickupInfo {
      flex-direction: column;
      height: 120px;
      align-items: baseline;
      padding: 10px 0;
    }
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  width: 600px;
  max-width: calc(100% - 100px);
  .bg {
    width: 100%;
    height: 12px;
    background: #e8e8e8;
    border-radius: 6px;
    position: relative;
  }
  .pointer {
    font-size: 14px;
    color: #7a7a7a;
    position: absolute;
    top: 0;
    transform: translate(-50%, -5.5px);
    text-align: center;
    .checkpoint {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      border: 1px solid #696969;
      margin: 8px auto;
    }
    &.PENDING,
    &.CANCEL_REQUESTED {
      left: 10%;
    }
    &.CONFIRMED {
      left: 30%;
    }
    &.READY {
      left: 50%;
    }
    &.COMPLETED {
      left: 70%;
    }
    &.PICKUP,
    &.CANCELLED {
      left: 90%;
    }
  }
  .line {
    top: 50%;
    left: 2px;
    position: absolute;
    height: 8px;
    width: 10%;
    transform: translateY(-50%);
    background: #255dac;
    border-radius: 4px;
    &.CANCELLED,
    &.CANCEL_REQUESTED {
      background: rgb(183, 74, 74);
    }
    &.CONFIRMED {
      width: 30%;
    }
    &.READY {
      width: 50%;
    }
    &.COMPLETED {
      width: 70%;
    }
    &.PICKUP,
    &.CANCELLED {
      width: calc(100% - 2px);
    }
  }
  @media screen and (max-width: 1050px) {
    width: 100%;
    max-width: 100%;
  }
  @media screen and (max-width: 767px) {
    align-items: baseline;
    height: 40px;
  }
`;

export const RequestsContainer = styled.div`
  height: 70px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .remark {
    display: flex;
    height: 100%;
    width: 600px;
    max-width: calc(100% - 100px);
    background: rgba(246, 46, 46, 0.1);
    color: #fd5959;
    font-size: 18px;
    overflow-y: auto;
    padding: 0 10px;
    span {
      margin: auto 0;
      display: inline-block;
    }
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #5a5a5a;
      border-radius: 10px;
      border: 2px solid #d9d9d9;
    }
    &::-webkit-scrollbar-track {
      background-color: #d9d9d9;
      border-radius: 10px;
    }
  }
  @media screen and (max-width: 767px) {
    height: 85px;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    margin: 10px 0;
    flex-wrap: wrap;
    .label {
      font-weight: 700;
    }
    .remark {
      height: auto;
      padding: 10px 0 10px 10px;
      max-width: 100%;
      width: 100%;
      font-size: 12px;
    }
  }
`;

export const OrderMenuContainer = styled.div`
  width: 100%;
  height: calc(100% - 360px);
  flex-direction: column;
  overflow-y: auto;
  &.PICKUP {
    height: calc(100% - 280px);
  }
  .foodItem {
    width: 50%;
    display: flex;
    align-items: center;
    .tit {
      font-weight: 700;
    }
    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
      margin-right: 10px;
      border-radius: 5px;
    }
  }
  .foodQuantity {
    width: 20%;
    text-align: center;
  }
  .foodPrice {
    width: 30%;
    text-align: center;
  }
  .info {
    border-bottom: 1px solid #000;
    font-weight: 700;
    padding: 10px 0;
    display: flex;
    align-items: center;
    height: 70px;
    span {
      display: inline-block;
      line-height: normal;
    }
  }
  ul {
    height: calc(100% - 70px);
    margin-bottom: 10px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #5a5a5a;
      border-radius: 10px;
      border: 2px solid #d9d9d9;
    }
    &::-webkit-scrollbar-track {
      background-color: #d9d9d9;
      border-radius: 10px;
    }
  }
  .food {
    width: 100%;
    padding: 20px 0;
    height: auto;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid #efefef;
    font-size: 24px;
    .options {
      font-size: 20px;
      width: 100%;
      margin-bottom: 0;
      li {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
        color: #5a5a5a;
        &:last-child {
          margin-bottom: 0;
        }
        span {
          &:first-child {
            width: 70%;
            position: relative;
            padding-left: 20px;
            i {
              position: absolute;
              top: 0;
              right: 100%;
              transform: translateX(100%);
            }
          }
          &:last-child {
            text-align: center;
            width: 30%;
            /* background: #000; */
          }
        }
      }
    }
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  @media screen and (max-width: 1050px) {
    height: calc(100% - 340px);
    &.PICKUP {
      height: calc(100% - 260px);
    }
    ul {
      height: calc(100% - 70px);
    }
    .info {
      font-size: 20px;
      height: 50px;
    }
    .food {
      padding: 10px 0;
      font-size: 18px;
      .options {
        font-size: 16px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .info {
      font-size: 14px;
      line-height: 0;
      padding: 0 0 10px;
      height: 31px;
      .label {
        font-size: 14px;
        padding: 0;
        height: 100%;
        line-height: normal;
        width: 40%;
      }
    }
    .foodItem.label,
    .food .foodItem {
      width: 50%;
    }
    .foodPrice {
      width: 30%;
    }
    .foodQuantity {
      width: 20%;
    }
    .food {
      font-size: 14px;
      .foodItem {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .options li {
        font-size: 12px;
      }
    }
  }
`;

export const MobileOrderItems = styled.li`
  min-height: 108px;
  background: #fff;
  margin-bottom: 20px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  border-radius: 10px;
  padding: 15px;
  font-size: 14px;
  position: relative;
  &:last-child {
    margin-bottom: 0;
  }
  .dot {
    margin: 0;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    right: 10px;
    background: #635151;
    border-radius: 50%;
  }
  > div {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  button {
    font-weight: 700;
    border: none;
    background: transparent;
  }
  .orderInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    .info {
      width: calc(100% - 50px);
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .status {
      width: 45px;
      height: 45px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .infoImage {
      width: 30px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .infoText {
      width: calc(100% - 95px);
      span {
        display: block;
        &:first-child {
          font-weight: 700;
        }
        &:last-child {
          font-size: 12px;
        }
      }
    }
    .orderProgress {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      position: relative;
      overflow: hidden;
      &.red .wave {
        background: rgba(255, 47, 47, 0.4);
      }
      &.yellow .wave {
        background: rgba(214, 154, 41, 0.4);
      }
      &.green .wave {
        background: rgba(62, 204, 47, 0.4);
      }
      .progressRemaining {
        width: 38px;
        height: 38px;
        line-height: 38px;
        /* background: #fff; */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        text-align: center;
        font-weight: 700;
        font-size: 12px;
      }
      .wave {
        transition: top 0.75s ease;
        opacity: 0.4;
        position: absolute;
        top: 10px;
        left: 50%;
        background: rgba(0, 0, 0, 0.2);
        transform-origin: 50% 48%;
        border-radius: 41%;
        transition-duration: 0.75s;
        transition-property: margin-bottom;
        transition-timing-function: ease;
        &:nth-child(1) {
          width: 100px;
          height: 100px;
          animation: waveMove 7000ms infinite ease-in-out;
          animation-delay: 0s;
        }
        &:nth-child(2) {
          width: 80px;
          height: 80px;
          animation: waveMove 10000ms infinite ease-in-out;
          animation-delay: 1s;
        }

        &:nth-child(3) {
          width: 110px;
          height: 110px;
          animation: waveMove 7000ms infinite ease-in-out;
          animation-delay: 2s;
        }
      }
    }
  }
  .action {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 5px;
    font-weight: 700;
    &.stepper {
      button {
        background: #000;
        width: 20px;
        height: 20px;
        color: #fff;
        svg {
          display: block;
          margin: auto;
        }
      }
    }
    .current {
      display: inline-block;
      min-width: 40px;
      text-align: center;
    }
    .notify {
      width: 100%;
      height: 100%;
    }
  }
  .toggleButton {
    button {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    svg {
      display: block;
    }
  }
  .orderItemContent {
    overflow: hidden;
    transition: 0.3s;
    box-sizing: border-box;
  }
  .controls {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 30px;
    button {
      box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
      border: none;
      height: 100%;
      border-radius: 5px;
      font-weight: 700;
      &:first-child {
        flex-grow: 1;
      }
      &:last-child {
        background: #3e50da;
        color: #fff;
        flex-grow: 2;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .orderInfo .infoText {
      width: calc(100% - 80px);
    }
    &.PICKUP .orderInfo .info {
      width: 100%;
    }
    &.READY .orderInfo .info .infoImage:last-of-type {
      display: none;
    }
  }
`;

export const CustomerInfoContainer = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  gap: 20px;
  background: #255dac;
  border-radius: 20px 20px 0 0;
  padding: 0 20px;
  font-weight: 700;
  color: #fff;
  &.cancel {
    background: #000;
  }
  @media screen and (max-width: 1050px) {
    height: 50px;
    font-size: 20px;
  }
  @media screen and (max-width: 767px) {
    &.cancel {
      background: transparent;
      color: #ff6f6f;
    }
    border-radius: 0;
    font-size: 14px;
    background: transparent;
    display: block;
    color: #000;
    height: auto;
    padding: 0;
    border-bottom: 1px solid rgb(239, 239, 239);
    margin-bottom: 10px;
    padding-bottom: 10px;
    span {
      display: block;
    }
  }
`;
